import { SystemStyleObject } from "@chakra-ui/react";

export const filterPopUpMenuContentCss: SystemStyleObject = {
  width: "384px",
  maxHeight: "413px",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  border: "1px solid #F2F4F7",
  boxShadow: "0px 12px 16px -4px #10182814",
  padding: "0",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};
